import emailjs from 'emailjs-com';

// Function to register a user

export const sendEmail = async (formData) => {
  try {
      const templateParams = {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message
      };

      const response = await emailjs.send(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          templateParams,
          process.env.REACT_APP_EMAILJS_USER_ID
      );

      return response.data; // Or a success message
  } catch (error) {
      console.error('Error sending email:', error);
      throw error; // Re-throw the error for the component to handle
  }
};


export const sendResume = async (formData) => {
  try {
      const templateParams = {
          name: formData.name,
          email: formData.email,
          phone: formData.phone,
          message: formData.message,
          resume: formData.resume
      };

      const response = await emailjs.send(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          templateParams,
        process.env.REACT_APP_EMAILJS_USER_ID
      );

      return response.data; // Or a success message
  } catch (error) {
      console.error('Error sending email:', error);
      throw error; // Re-throw the error for the component to handle
  }
};
